import React from 'react';

const PdfCustomizationPanel = ({
  pdfScale,
  setPdfScale,
  pdfTranslateX,
  setPdfTranslateX,
  pdfTranslateY,
  setPdfTranslateY,
  scaleFromSheetCenter,
  setScaleFromSheetCenter
}) => {
  return (
    <div className="panel-content">
      <div className="input-group">
        <label>
          Scale:
          <input
            type="number"
            step="0.1"
            min="0.1"
            max="2"
            value={pdfScale}
            onChange={(e) => setPdfScale(parseFloat(e.target.value))}
          />
        </label>
      </div>

      <div className="input-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={scaleFromSheetCenter}
            onChange={(e) => setScaleFromSheetCenter(e.target.checked)}
          />
          Scale from center
        </label>
      </div>

      <div className="input-group">
        <label>
          X Offset:
          <input
            type="number"
            step="1"
            value={pdfTranslateX}
            onChange={(e) => setPdfTranslateX(parseInt(e.target.value))}
          />
        </label>
      </div>

      <div className="input-group">
        <label>
          Y Offset:
          <input
            type="number"
            step="1"
            value={pdfTranslateY}
            onChange={(e) => setPdfTranslateY(parseInt(e.target.value))}
          />
        </label>
      </div>
    </div>
  );
};

export default PdfCustomizationPanel; 